class InfoSlider extends HTMLElement {
    constructor() {
        super();
        this.sliderElement = this.querySelector('.info-slider__slider');
        this.slider = true;
        this.Flickity = true;

        // Init and destroy slider depend on screen size
        if (window.innerWidth < 960) {
            this.initSlider();
        }

        addEventListener("resize", (event) => {
            if (window.innerWidth >= 960 && this.slider) {
                this.destroySlider();
            }
            if (window.innerWidth < 960 && !this.slider?.isActive) {
                this.initSlider();
            }
        });
    }

    initSlider() {
        import(flu.chunks.flickity).then(({
            Flickity
        }) => {
            if (this.sliderElement) {
                this.Flickity = Flickity;
                this.slider = new Flickity(this.sliderElement, {
                    cellAlign: 'left',
                    prevNextButtons: false,
                    pageDots: true,
                    groupCells: true,
                    contain: true
                });

                this.slider.on("scroll", progress => {
                    const progressScale = progress * 100;
                });
            }
        });
    }

    destroySlider() {
        this.slider.destroy();
    }
}

customElements.define("info-slider", InfoSlider);